import { render, staticRenderFns } from "./wallet_list.vue?vue&type=template&id=1776bbb4&scoped=true"
import script from "./wallet_list.vue?vue&type=script&lang=js"
export * from "./wallet_list.vue?vue&type=script&lang=js"
import style0 from "./wallet_list.vue?vue&type=style&index=0&id=1776bbb4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1776bbb4",
  null
  
)

export default component.exports